import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import axiosInstance, { clearAuthData, isJwtAuthFailure } from "../../components/content/axiosConfig";
import { enqueueSnackbar } from "notistack";
import Preloader from "../../components/custom/preLoader";
import ListPagination from "../../components/custom/ListPagination";
import useServerPaginatedList from "../../hooks/useServerPaginatedList";
import { formatDisplayDateTime as formatDateTime, formatFishingSamplingFileLabel } from "../../utils/formatDisplayDate";

const PondDetail = () => {
  const fetchPondDetailPage = useCallback(async ({ search, page, limit }) => {
    try {
      return await axiosInstance.get(`/api/PondDetail/GetAllDetails`, {
        params: { search, page, limit },
      });
    } catch (error) {
      if (isJwtAuthFailure(error)) {
        clearAuthData();
        window.location.href = "/user/login";
        return { data: { data: [], total: 0 } };
      }
      let errorMessage = "An error occurred.";
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }
      enqueueSnackbar(errorMessage, {
        variant: 'error',
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        autoHideDuration: 3000,
      });
      throw error;
    }
  }, []);

  const {
    rows: pondDetails,
    totalCount,
    searchTerm,
    setSearchTerm,
    currentPage,
    setCurrentPage,
    isLoading,
    entriesPerPage,
  } = useServerPaginatedList(fetchPondDetailPage);

  if (isLoading) {
    return <Preloader />;
  }

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item active">Pond Details</li>
          </ul>
          <h1 className="page-header mb-0">Pond Details</h1>
        </div>
        <div className="ms-auto" />
      </div>

      <div className="card border-0">
        <div className="tab-content p-3">
          <div className="tab-pane fade show active" id="allTab">
            <div className="input-group mb-3">
              <div className="flex-fill position-relative">
                <div className="input-group">
                  <div
                    className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 start-0"
                    style={{ zIndex: 10 }}
                  >
                    <i className="fa fa-search opacity-5"></i>
                  </div>
                  <input
                    type="text"
                    className="form-control px-35px bg-light"
                    placeholder="Search Pond Detail..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="table-responsive mb-3">
              <table className="table table-hover table-panel text-nowrap align-middle mb-0">
                <thead>
                  <tr>
                    <th>Pond</th>
                    <th>Name</th>
                    <th>Air Tem</th>
                    <th>Sky Climate</th>
                    <th>Wind Speed</th>
                    <th>Moon Phase</th>
                    <th>BaroMetric Pressure </th>
                    <th>Forage Stocking </th>
                    <th>Account </th>
                    <th>Updated At </th>
                    <th>Actions </th>
                  </tr>
                </thead>
                <tbody>
                  {pondDetails.length === 0 ? (
                    <tr>
                      <td colSpan={11} className="text-center text-muted py-5">
                        No pond details found.
                      </td>
                    </tr>
                  ) : (
                    pondDetails.map((report) => (
                      <tr key={report.id}>
                        <td>{report.PondName}</td>
                        <td>{formatFishingSamplingFileLabel(report)}</td>
                        <td>{report.AirTemperature}</td>
                        <td>{report.SkyClimate}</td>
                        <td>{report.WindSpeed}</td>
                        <td>{report.MoonPhase}</td>
                        <td>{report.BaroMetricPressure}</td>
                        <td>{report.ForageStocking}</td>
                        <td>{report.FisherName}</td>
                        <td>{formatDateTime(report.updatedAt)}</td>
                        <td>
                          <span>
                            <Link to={`/pondDetailOverview/${report.id}`}>
                              <i className="fa fa-eye fs-13px fa-fw me-5px"></i>
                            </Link>
                          </span>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <ListPagination
              currentPage={currentPage}
              totalCount={totalCount}
              entriesPerPage={entriesPerPage}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PondDetail;
